export default __webpack_public_path__ + "static/media/Resume 2021.f0fd617a.pdf";